module.exports = __webpack_public_path__ + "media/images/cloud-streams-badge-tiny-375ebb3a.svg";